import { Field } from 'react-final-form';
import { Flex } from 'components/box';
import { Text } from 'components/typography';
import {
  contactNumberPrefix,
  displayPhoneNumber,
  formatPhoneNumber,
} from '../../../util/contact-number';
import FlagIcon from 'icons/za-flag.svg';
import InputGroup, { InputGroupProps } from 'components/form/input/group';
import { css } from '@emotion/react';

const ContactNumberField = ({
  fieldProps = {},
  fieldName = 'contactNumber',
  inputProps = {},
  inputLabel = 'Contact Number',
  isRequired = false,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldProps?: any;
  fieldName?: string;
  inputProps?: InputGroupProps;
  inputLabel?: string;
  isRequired?: boolean;
}) => (
  <Field
    name={fieldName}
    parse={formatPhoneNumber}
    validate={value => {
      if (isRequired && !value) {
        return `Please enter your ${inputLabel.toLowerCase()}`;
      }
      if (value && value.replace(/\D/g, '').length < 11) {
        return `Please enter a valid ${inputLabel.toLowerCase()}`;
      }
      if (value && value.replace(/\D/g, '').length > 11) {
        return `${inputLabel} too long`;
      }
    }}
    {...fieldProps}
  >
    {({ input, meta }) => (
      <InputGroup
        {...input}
        value={displayPhoneNumber(input.value)}
        label={inputLabel}
        type="tel"
        // Full mobile number with display formatting is 14 characters long
        maxLength={14}
        placeholder="(0xx) xxx-xxxx"
        invalid={meta.error && meta.touched}
        error={meta.touched && meta.error}
        {...inputProps}
        groupPrefix={
          <Flex alignItems="center">
            <FlagIcon
              height={20}
              css={theme => css`
                border-right: 1px solid ${theme.colors.borderColor};
                padding-left: ${theme.space[1]}px;
                padding-right: ${theme.space[3]}px;
                margin-right: 12px;
              `}
            />
            <Text color="mediumGrey">{contactNumberPrefix}</Text>
          </Flex>
        }
      />
    )}
  </Field>
);

export default ContactNumberField;
